import React, { useState, useEffect } from 'react';
import s from '../styles/ResetPasswordForm.module.css';
import { Link } from 'react-router-dom';

function ResetPasswordForm() {
  const [key, setKey] = useState('');
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const urlKey = new URLSearchParams(window.location.search).get('key');
    if (urlKey) {
      setKey(urlKey);
      fetch(`/api/get-login-from-key?key=${urlKey}`)
        .then(res => res.json())
        .then(data => {
          if (data.login) setLogin(data.login);
          else setError('Неверный или просроченный ключ.');
        })
        .catch(() => setError('Ошибка при получении логина.'));
    } else {
      setError('Ключ не указан в ссылке.');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Пароли не совпадают.');
      return;
    }

    try {
      const res = await fetch('/api/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key, password }),
      });

      const data = await res.json();
      if (res.ok) {
        setSuccess('Пароль успешно изменён!');
      } else {
        setError(data.error || 'Ошибка сброса пароля.');
      }
    } catch {
      setError('Ошибка соединения с сервером.');
    }
  };

  return (
    <div className={s.container}>
      <h2 className={s.title}>Сброс пароля</h2>

      {error && <div className={s.error}>{error}</div>}
      {success ? (
        <div className={s.success}>{success}</div>
      ) : (
        <form onSubmit={handleSubmit} className={s.form}>
          <div className={s.field}>
            <label className={s.label}>Логин:</label>
            <div className={s.loginText}>{login}</div>
          </div>
          <div className={s.field}>
            <label className={s.label}>Новый пароль:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={s.input}
            />
          </div>
          <div className={s.field}>
            <label className={s.label}>Повторите пароль:</label>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              className={s.input}
            />
          </div>
          <button type="submit" className={s.button}>Сбросить пароль</button>
        </form>
      )}
      <div className={s.backLinkContainer}>
        <Link to="/" className={s.backLink}>← На главную</Link>
      </div>
    </div>
  );
}

export default ResetPasswordForm;
